export const MYDESKTOP_EMAIL_TEMPLATE = {
  to: 'xmlteam@mydesktop.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello MyDesktop

Could you please enable Snug as an upload destination for our agency for the MyDesktop Account(s):

<enter your account number eg. 23456>

Thank you,

<Your authorised person>`,
}
